import React from "react"
import { composeSx } from "../theme/composeSx"
import { IconButton, type IconButtonProps, type Theme } from "@mui/material"
import { resolveViraPalette } from "../theme/resolveViraPalette"

export type ViraIconButtonVariant = "ghost" | "outlined" | "filled"

export type ViraIconButtonProps = IconButtonProps & {
  variant?: ViraIconButtonVariant
}

function variantSx(theme: Theme, variant: ViraIconButtonVariant): object {
  const vira = resolveViraPalette(theme)
  switch (variant) {
    case "ghost":
      return {
        color: vira.subtle,
        "&:hover": { backgroundColor: vira.pageBg },
      }
    case "outlined":
      return {
        width: 40,
        height: 40,
        [theme.breakpoints.up("sm")]: {
          width: 26,
          height: 26,
        },
        border: `1px solid ${vira.border}`,
        borderRadius: "6px",
        color: vira.subtle,
        "&:hover": { backgroundColor: vira.pageBg },
      }
    case "filled":
      return {
        backgroundColor: vira.lavender,
        border: `1px solid ${vira.lavenderBorder}`,
        borderRadius: "8px",
        color: vira.lavenderText,
        "&:hover": { backgroundColor: vira.navActiveBg },
      }
  }
}

export function ViraIconButton({
  variant = "ghost",
  disabled,
  sx,
  children,
  ...rest
}: ViraIconButtonProps) {
  return (
    <IconButton
      disabled={disabled}
      size="small"
      sx={composeSx((theme) => ({
        ...variantSx(theme, variant)}), sx)}
      {...rest}
    >
      {children}
    </IconButton>
  )
}
